interface ChatDateSeparatorProps {
  date: string // YYYY-MM-DD
}

function formatDateLabel(date: string): string {
  const target = new Date(date + 'T00:00:00')
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const diff = Math.floor((today.getTime() - target.getTime()) / (1000 * 60 * 60 * 24))

  if (diff === 0) return '오늘'
  if (diff === 1) return '어제'

  const month = target.getMonth() + 1
  const day = target.getDate()
  return `${month}월 ${day}일`
}

export function ChatDateSeparator({ date }: ChatDateSeparatorProps) {
  return (
    <div className="flex items-center gap-3 py-3">
      <div className="flex-1 h-px bg-border-base" />
      <span className="text-xs text-caption px-2">
        {formatDateLabel(date)}
      </span>
      <div className="flex-1 h-px bg-border-base" />
    </div>
  )
}
